import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const FormatMessage = ({ intlMessage, values, className }) => (
    <div className={className}>
        <FormattedMessage {...intlMessage} values={values} />
    </div>
);

FormatMessage.defaultProps = {
    values: undefined,
    currency: 'USD',
    className: undefined
};

FormatMessage.propTypes = {
    intlMessage: PropTypes.object.isRequired,
    values: PropTypes.object,
    currency: PropTypes.string,
    className: PropTypes.string
};
